<section class="page-banner">
    <div class="page-title-container">
        <div class="page-title">
            {{ 'Services' | translate }}
        </div>
        <div class="page-subtitle" [innerHTML]="'When it comes to the performance of your vehicle, you want quality service from trusted professionals. We’ll help you stay on the road so you can reach your next great destination.' | translate"></div>
    </div>
    <div class="page-screen"></div>
</section>
<section id="services" class="padding-top-3 padding-bottom-3">
    <div class="d-flex flex-row justify-content-center">
        <div class="max-width">
            <div id="services_list" class="page-section">
                <div class="item-list">
                    <ul>
                        <ng-container *ngFor="let service of services">
                            <li>
                                <i class="{{service.icon}}"></i>
                                <h5 class="font-main3">{{service.title | translate}}</h5>
                                <div [innerHTML]="service.subtitle | translate"></div>
                            </li>
                        </ng-container>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</section>
